var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { "enter-active-class": "uk-animation-fade" } },
    [
      _c(
        "nav",
        { staticClass: "uk-navbar-container", attrs: { "uk-navbar": "" } },
        [
          _c("div", { staticClass: "uk-navbar-center" }, [
            _c("ul", { staticClass: "uk-navbar-nav" }, [
              _c(
                "li",
                { class: { active: _vm.$route.name == "ListContact" } },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "ListContact" } } },
                    [
                      _c("span", {
                        attrs: { "uk-icon": "icon:  user; ratio: 2.0" }
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { class: { active: _vm.$route.name == "ListChat" } },
                [
                  _c("router-link", { attrs: { to: { name: "ListChat" } } }, [
                    _c("span", {
                      attrs: { "uk-icon": "icon:   comment; ratio: 2.0" }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.msgCount != 0,
                            expression: "msgCount != 0"
                          }
                        ],
                        staticClass: "badge"
                      },
                      [_vm._v(_vm._s(_vm.msgCount))]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "nav-new-cust",
                  class: _vm.newCustomerClass,
                  on: { click: _vm.getNextCustomer }
                },
                [
                  _c("a", [
                    _c("i", { staticClass: "fas fa-comment-alt fa-2x" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "new-customer-badge" }, [
                      _vm._v(" New")
                    ])
                  ])
                ]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1659d81e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1659d81e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMobile.vue
// module id = null
// module chunks = 